/**
 * @file Parametres par defaut de chacun des 7 comportements d'armes (portee, vitesse, rayon, dispersion, recul...).
 */
import type { WeaponBehavior } from '@shared/enums';
import type { BehaviorParams } from './types';

const base: BehaviorParams = {
  range: 12,
  projectileSpeed: 28,
  projectileRadius: 0.18,
  spreadMinDeg: 0,
  spreadMaxDeg: 4,
  spreadParamScale: 0.5,
  spreadGrowthDegPerSec: 18,
  spreadResetSeconds: 0.5,
  pelletsBase: 3,
  pelletsFromParam: true,
  pelletDamageRatio: 0.5,
  shotgunConeDeg: 34,
  pierceMaxHits: 99,
  pierceFalloff: 1,
  explosionRadiusScale: 0.25,
  explosionFalloffAtEdge: 0.5,
  missileArcHeight: 3,
  missileHoming: false,
  beamWidth: 0.35,
  beamVisibleSeconds: 0.12,
  kickback: 0.25,
  muzzleFlashSeconds: 0.06,
};

/** Valeurs par defaut ; chaque comportement ne surcharge que ce qui le distingue. */
export const BEHAVIOR_PARAMS: Record<WeaponBehavior, BehaviorParams> = {
  single: { ...base, range: 12, projectileSpeed: 30 },
  pierce: { ...base, range: 14, projectileSpeed: 34, projectileRadius: 0.22, kickback: 0.3 },
  shotgun: { ...base, range: 7, projectileSpeed: 24, projectileRadius: 0.16, kickback: 0.45 },
  explosive: { ...base, range: 11, projectileSpeed: 18, projectileRadius: 0.28, kickback: 0.5, muzzleFlashSeconds: 0.08 },
  laser: { ...base, range: 16, projectileSpeed: 0, beamWidth: 0.3, kickback: 0.2, beamVisibleSeconds: 0.14 },
  missile: { ...base, range: 14, projectileSpeed: 14, projectileRadius: 0.3, kickback: 0.55, missileArcHeight: 3.2, missileHoming: false, muzzleFlashSeconds: 0.1 },
  blastSniper: { ...base, range: 16, projectileSpeed: 0, beamWidth: 0.4, kickback: 0.6, beamVisibleSeconds: 0.18, muzzleFlashSeconds: 0.1 },
};
